import styled from 'styled-components';
import { theme } from 'assets/styles/theme';
import { DeviceUp } from 'assets/styles/breakpoints';

export const Styled = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  .section-loader {
    position: absolute;
    height: auto;
  }
`;

export const MainContainer = styled.div`
  background: #ECF0F4;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
`;

export const MainContent = styled.div`
  background: ${theme.bodyBg};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;
  padding: 16px;

  @media ${DeviceUp.sm} {
    padding: 20px;
  }
  min-height: 350px;

  @media ${DeviceUp.lg} {
    padding: 30px 35px;
  }

  @media ${DeviceUp.xl} {
    padding: 41px 89px 30px 61px;
  }
`;
